import React from "react";
import Meta from "components/Meta";
import AboutSection from "components/AboutSection";

function AboutPage() {
  return (
    <>
      <Meta title="About" description="Learn about our company and team" />
      <section>
        <AboutSection />
      </section>
    </>
  );
}

export default AboutPage;
